import { InteractionRequiredAuthError } from '@azure/msal-browser';

import { msalInstance, loginRequest } from './config';

export async function acquireToken() {
  const account = msalInstance.getActiveAccount();

  if (!account) {
    return;
  }

  const request = {
    account,
    ...loginRequest
  };

  try {
    const response = await msalInstance.acquireTokenSilent(request);

    return response.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request);
    }

    throw err;
  }
}
